//This is only in its own function to mock it easier... HAHAH! what a loser, I bet its own mom doesn't even love it.
export const getWWWBaseUrl = () => process.env.WWW_BASE_URL
export const CAREERS_URL =
  'https://app.trinethire.com/companies/37151-custodia-bank-inc/jobs/embed'
